import React from 'react'

import {
  AlignItems,
  Body3,
  Box,
  Color,
  Display,
  Divider,
  FlexDirection,
  FontWeight,
  Heading6,
  Image,
  JustifyContent,
  Space,
} from '@gousto-internal/citrus-react'

type RecipeListItemProps = {
  title: string
  servings: number
  imageUrl?: string
}

export const RecipeListItem = ({ title, servings, imageUrl }: RecipeListItemProps) => (
  <Box display={Display.Flex} flexDirection={FlexDirection.Column} gap={3} paddingV={1}>
    <Box
      display={Display.Flex}
      flexDirection={FlexDirection.Row}
      alignItems={AlignItems.FlexStart}
      justifyContent={JustifyContent.FlexStart}
    >
      <Image
        alt={title}
        src={imageUrl}
        width="72px"
        height="72px"
        style={{
          objectFit: 'cover',
          flexShrink: 0,
        }}
      />
      <Space size={3} direction="horizontal" />
      <Box
        display={Display.Flex}
        flexDirection={FlexDirection.Column}
        justifyContent={JustifyContent.FlexStart}
        style={{ minHeight: 72 }}
        gap={0.5}
      >
        <Heading6 size={3} fontWeight={FontWeight.Bold} color={Color.ColdGrey_800}>
          {title}
        </Heading6>
        <Body3 size={3} color={Color.ColdGrey_800}>
          {servings} servings
        </Body3>
      </Box>
    </Box>
    <Divider />
  </Box>
)
